<span style="padding: 15px;"><strong>Loan Servicing</strong> | Reports/Account Informations</span>
<mat-tab-group style="height:  calc(100% - 30px);">
    <mat-tab label="Current Account Information">
        <app-current-account-information></app-current-account-information>
    </mat-tab>
    <mat-tab label="SPV Account Information (Vintage)">
        <app-spv-custom-account-information></app-spv-custom-account-information>
    </mat-tab>
</mat-tab-group>